import React from 'react'
import Select from "react-select";
import { useTranslation } from "react-i18next";

const NewCatalogLocationGeneric = ({ handleChange, values, errors, placeholderVal, field, moduleText, occupation, comboData }) => {
  const { t } = useTranslation();

  const hasError = Boolean(errors?.[field]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: hasError ? "#dc3545" : provided.borderColor,
      boxShadow: hasError ? "0 0 0 1px #dc3545" : provided.boxShadow
    }),
    option: (provided, state) => ({
      ...provided,

      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      
      fontSize: state.selectProps.myFontSize,
      fontWeight: state.selectProps.myFontWeight,
    }),
  };

  return (
    <div className={`col-md-${occupation}`}>
      <label htmlFor={field} className="form-label tit-view">
      {t(`${moduleText}.short.${field}`)}</label>
      <div className="control">
        <Select
          styles={customStyles}
          myFontSize="14px"
          onChange={(event) => handleChange(event, field)}
          
          className={`form-control txt-view ${hasError ? "border border-danger" : ""}`}
          classNamePrefix="select"
          name={field}
          
          inputId={field}
          value={values[field]}
          options={comboData}
          getOptionLabel={(option) => `${option.id} - ${option.name}`}
          getOptionValue={(option) => `${option}`}
          isClearable={true}
          isSearchable={true}
          placeholder={placeholderVal ? t("combo.placeholder") : null}
        />
        {errors[field] && <pre> <p className="help text-danger">{errors[field]}</p> </pre>}
      </div>
    </div>
  )
}

export default NewCatalogLocationGeneric;